import gql from 'graphql-tag';

import { DOMAIN_FRAGMENT } from '../fragments/Domain/domain';
import { PLEX_OVERVIEW_FRAGMENT } from '../fragments/Plex/plexOverview';
import { USER_SETTINGS_FRAGMENT } from '../fragments/User/userSettings';

export const GET_LOGGED_IN_USER_QUERY = gql`
  query GetLoggedInUser {
    currentUser {
      id
      email
      status
      plexes {
        ...plexOverview
      }
      domain {
        ...domain
      }
      ...userSettings
    }
  }

  ${PLEX_OVERVIEW_FRAGMENT}
  ${USER_SETTINGS_FRAGMENT}
  ${DOMAIN_FRAGMENT}
`;

export { useGetLoggedInUserQuery } from '../gen/types';
